/**
 * External dependencies
 */
import { useMemo } from 'react';
import Theme from '@naruto/naruto-theme/src';
import { ThemeOptions } from '@naruto/naruto-theme/src/types';

/**
 * Internal dependencies
 */
import { ThemeLocalConfig, ThemeLocalKeys } from '@naruto/bgdcms/src/base/theme';
import useMappedState from '@naruto/bgdcms/src/hooks/useMappedState';

/**
 * 描述 : 取得客製化主題
 */
export default function useTheme(): ThemeOptions {
  /* Global & Local State */
  const storeGlobal = useMappedState(state => state.global);

  /* Data */
  const themeInstance = useMemo(() => new Theme(ThemeLocalConfig), []);

  /* Main */
  return useMemo(() => {
    if (storeGlobal.globalThemeVersion) {
      return themeInstance.createTheme(storeGlobal.globalThemeVersion);
    }
    return themeInstance.createTheme(ThemeLocalKeys.DEFAULT);
  }, [storeGlobal.globalThemeVersion]);
}
